import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Card } from '@uhg-abyss/web/ui/Card';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { Text } from '@uhg-abyss/web/ui/Text';
import { WelcomeText } from '../WelcomeText';

const DialogContainer = styled('div', {
  textAlign: 'center',
  marginTop: '50px',
});

const CardTitle = styled(Heading, {
  '&.abyss-heading-root': {
    fontFamily: 'UHCSerif,Georgia Bold,serif',
    fontWeight: '$semibold',
    fontSize: '1.802rem',
    lineHeight: '2.25rem',
    textAlign: 'center',
  },
});

const PaddedBox = styled(Box, {
  '&.abyss-box-root': {
    padding: '50px 0px 20px',
  },
});

const MessageContainer = styled('div', {
  padding: '0px 20%',
});

const CenteredText = styled(Text, {
  '&.abyss-text-root': {
    display: 'inline-block',
  },
});

const BodyContainer = styled('div', {
  padding: '0 20px',
  textAlign: 'center',
});

const MarginTop = styled('div', {
  marginTop: 10,
});

const StyledCard = styled(Card, {
  width: '75%',
  margin: '0 auto',
  '@media (max-width: 820px)': {
    width: '90%',
  },
});

const StyledLayoutStack = styled(Layout.Stack, {
  '&.abyss-layout-stack': {
    paddingBottom: '50px !important',
  },
});
export const PaperlessDeliveryUserCard = () => {
  const { getHomePageContentByKey, getMessage } = usePPDLagoon();
  const paperlessDeliveryUserCardTitle = getMessage(
    'paperless-delivery-user-card-title'
  );
  const paperlessDeliveryUserCardMessage = getMessage(
    'paperless-delivery-user-card-message'
  );
  const splittedPaperlessDeliveryUserCardMessage =
    paperlessDeliveryUserCardMessage.split('|');

  const paperlessExceptions = getHomePageContentByKey('PAPERLESSEXCEPTIONS');
  return (
    <DialogContainer>
      <MarginTop>
        <WelcomeText />
      </MarginTop>
      <StyledCard>
        <PaddedBox color="white">
          <Layout.Stack alignLayout="center" space={16}>
            <IconBrand
              icon="settings"
              size="xl"
              data-testid="icon-brand-settings"
            />
            <CardTitle offset={2}>{paperlessDeliveryUserCardTitle}</CardTitle>
          </Layout.Stack>
        </PaddedBox>
        <BodyContainer>
          <StyledLayoutStack
            alignLayout="center"
            alignItems="center"
            space={20}
            grow
          >
            <MessageContainer>
              <CenteredText>
                {splittedPaperlessDeliveryUserCardMessage[0]}
              </CenteredText>
              <CenteredText>
                {splittedPaperlessDeliveryUserCardMessage[1]} &nbsp;
                <Link
                  fontWeight="$bold"
                  href={paperlessExceptions.href}
                  hideIcon
                >
                  "{paperlessExceptions.name}".
                </Link>
              </CenteredText>
            </MessageContainer>
          </StyledLayoutStack>
        </BodyContainer>
      </StyledCard>
    </DialogContainer>
  );
};
